module.exports = __webpack_public_path__ + "static/media/kinto-one-logo.99d8a73d.svg";